import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { RatingBadgeChip } from '@/components/common';
import type { SkillRatings, SkillRatingScale } from '@/api/types/jobEnd.types';

interface ProjectRatingsTableProps {
  skillRatings: SkillRatings | null;
  isComplete: boolean;
  displayMode?: string;
}

export function ProjectRatingsTable({ skillRatings, isComplete, displayMode }: ProjectRatingsTableProps) {
  if (!isComplete || !skillRatings) {
    return null;
  }

  const isSimplified = (displayMode ?? skillRatings.displayMode) === 'simplified';

  const renderRatingCell = (rating: SkillRatingScale | null) => {
    if (isSimplified) {
      return <RatingBadgeChip code={rating ?? 'NA'} labelMode="simplified" showTooltip />;
    }
    return <RatingBadgeChip code={rating} labelMode="full" />;
  };

  return (
    <>
    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
      Job End Ratings
    </Typography>
    <Box sx={{ overflowX: 'auto', mb: 2 }}>
      <Table
        size="small"
        sx={{
          minWidth: (skillRatings.skillAreas.length + 1) * 140,
          tableLayout: 'fixed',
          '& thead th': {
            height: 'auto',
            lineHeight: 1.3,
            py: 1,
            whiteSpace: 'normal',
            overflow: 'visible',
          },
        }}
      >
        <TableHead>
          <TableRow>
            {skillRatings.skillAreas.map((area) => (
              <TableCell key={area.areaId} align="center" sx={{ width: 140 }}>
                {area.areaName}
              </TableCell>
            ))}
            <TableCell align="center" sx={{ width: 140 }}>
              Overall Rating
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {skillRatings.skillAreas.map((area) => (
              <TableCell key={area.areaId} align="center">
                {renderRatingCell(area.skills[0]?.rating ?? null)}
              </TableCell>
            ))}
            <TableCell align="center">
              {renderRatingCell(skillRatings.overallRating)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
    </>
  );
}

export default ProjectRatingsTable;
